import React ,{useState,useEffect} from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
// import MatchList from '../components/MatchList'; done
// import CasinoGames from '../components/CasinoGames'; done
// import { useBetting } from '../context/BettingContext';
// import LoadingSpinner from '../components/LoadingSpinner';
// import Sidebar from '../components/Sidebar';
// import SideNavbar from '../components/SideNavbar'; 
import img1 from '../assets/frontimges/casinonew2.jpeg'
import img2 from '../assets/frontimges/statementnew2.jpeg'
import img3 from '../assets/frontimges/rules2.jpeg'
import img4 from '../assets/frontimges/profilenew2.jpeg'
import img5 from '../assets/frontimges/passwordnew3.png'
import img6 from '../assets/frontimges/ledgernew2.jpeg'
import img7 from '../assets/frontimges/inplaynew2.jpeg'

const PageWrapper = styled.div`
  min-height: 71vh;
  // background: white;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const GridContainer = styled.div`
  background: #f9f9f9;
  border-radius: 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(4, 1fr);
  gap: 32px 48px;
  padding: 48px 32px;
  width: 400px;

  @media (max-width: 500px) {
    width: 98vw;
    padding: 16px 2vw;
    gap: 18px 0;
  }
`;

const GridItem = styled.button`
  background: none;
  border: none;
  outline: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: transform 0.1s;
  min-width: 120px;
  min-height: 120px;
  &:hover {
    transform: scale(1.08);
  }
`;

const IconCircle = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  // background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  // box-shadow: 0 1px 4px rgba(0,0,0,0.06);
`;

const IconImg = styled.img`
  width: 48px;
  height: 48px;
  object-fit: contain;
`;

const ItemLabel = styled.div`
  font-weight: bold;
  font-size: 15px;
  color: #111;
  margin-top: 4px;
  text-align: center;
`;

const HomePage = () => {
  const navigate = useNavigate();
const [news, setNews] = useState([{ content: "Get Ready for Action - Welcome to 98FastBet!" }]);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BASE_URL}/api/platform/news`)
      .then((response) => {
        if (response.data.length > 0) {
          setNews(response.data)
        }
      })
      .catch((error) => console.error("Error fetching news:", error));
  }, []);
  return (
    <>
     <div>
      <div className="T20_header">
            <ScrollingTextContainer>
              <ScrollingText>
                <h3>{news[0].content}</h3>
              </ScrollingText>
            </ScrollingTextContainer>
          </div>
      </div>
    <PageWrapper>
      <GridContainer>
        <GridItem onClick={() => navigate('/matches')}>
          <IconCircle>
            <IconImg src={img7} alt="In Play" />
          </IconCircle>
          <ItemLabel>IN PLAY</ItemLabel>
        </GridItem>
        <GridItem onClick={() => navigate('/profile')}>
          <IconCircle>
            <IconImg src={img4} alt="Profile" />
          </IconCircle>
          <ItemLabel>PROFILE</ItemLabel>
        </GridItem>
        <GridItem onClick={() => navigate('/statement')}>
          <IconCircle>
            <IconImg src={img2} alt="Statement" />
          </IconCircle>
          <ItemLabel>STATEMENT</ItemLabel>
        </GridItem>
        <GridItem onClick={() => navigate('/change-password')}>
          <IconCircle>
            <IconImg src={img5} alt="Change Password" />
          </IconCircle>
          <ItemLabel>PASSWORD</ItemLabel>
        </GridItem>
        <GridItem onClick={() => navigate('/ledger')}>
          <IconCircle>
            <IconImg src={img6} alt="My Ledger" />
          </IconCircle>
          <ItemLabel>LEDGER</ItemLabel>
        </GridItem>
        <GridItem onClick={() => navigate('/games')}>
          <IconCircle>
            <IconImg src={img1} alt="Games" />
          </IconCircle>
          <ItemLabel>CASINO</ItemLabel>
        </GridItem>
        <GridItem onClick={() => navigate('/rules')}>
          <IconCircle>
            <IconImg src={img3} alt="Rules" />
          </IconCircle>
          <ItemLabel>RULES</ItemLabel>
        </GridItem>
         <GridItem onClick={() => navigate('/history')}>
          <IconCircle>
            <IconImg src={img2} alt="History" />
          </IconCircle>
          <ItemLabel>History</ItemLabel>
        </GridItem>
        <div /> {/* Empty cell for 8th grid spot, keeps layout even */}
      </GridContainer>
    </PageWrapper>
      <div>
      <div
      style={{
        backgroundColor: "#8AB7A6",
        padding: "1px"
      }}
    >
      <div
        style={{
         backgroundColor: "#8AB7A6",
          textAlign: "center",
          padding: "8px 0",
          cursor: "pointer",
        
        }}
      >
        <span
          style={{
            color: "#ffffff",
            fontWeight: "bold",
            fontSize: "14px",
            letterSpacing: "1px"
          }}
        >
          Copy Right @ yox9.com
        </span>
      </div>
    </div>
      </div>
  </>
  );
};

const ScrollingTextContainer = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;
  white-space: nowrap;
  flex: 1;
  margin-right: 0px;
  margin-top:-16px;
  @media (max-width: 768px) {
    max-width: 100%;
  }
`;
const ScrollingText = styled.div`
  display: inline-block;
  animation: scrollText 13s linear infinite;
  color: #ff8600;
  font-weight: 500;
  
  @keyframes scrollText {
    0% { transform: translateX(250%); }
    100% { transform: translateX(-100%); }
  }
  
  h3 {
    margin: 0;
    font-size: 20px;
    display: flex;
    align-items: center;
    
    svg {
      margin-right: 8px;
      animation: pulse 1.5s infinite;
      font-size: 22px;
    }
    
    @keyframes pulse {
      0% { transform: scale(1); }
      50% { transform: scale(1.2); }
      100% { transform: scale(1); }
    }
    
    @media (max-width: 768px) {
      font-size: 14px;
      
      svg {
        margin-right: 6px;
        font-size: 20px;
      }
       @keyframes scrollText {
        0% { transform: translateX(100%); }
        100% { transform: translateX(-100%); }
      }
    }
  }
`;

export default HomePage;
